import { render, staticRenderFns } from "./mutiUpload.vue?vue&type=template&id=9848f354&scoped=true"
import script from "./mutiUpload.vue?vue&type=script&lang=js"
export * from "./mutiUpload.vue?vue&type=script&lang=js"
import style0 from "./mutiUpload.vue?vue&type=style&index=0&id=9848f354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9848f354",
  null
  
)

export default component.exports